import React from "react";
import "./hostScreen.css";
import ClockIconSvg from "../../assets/ReactSvg/ClockIconSvg";
import RightIconSvg from "../../assets/ReactSvg/RightIconSvg";
import { S3_MENU_THUMBNAIL_FOLDER } from "../../store/constants";
import { getStatusLabel } from "../../utils/timeHelper";
import VerifiedIconSvg from "../../assets/ReactSvg/VerifiedIconSvg";
import LocationGreySvg from "../../assets/ReactSvg/LocationGreySvg";

const FoundersCuratedComponent = ({ founders, deliveryDetails, isServiceable, onChefClick }) => {
    return (
        <div className="hostChefListWrapper Satoshi">
            <div className="hostChefLabel Satoshi">Experts Curated</div>
            <div className="hostChefCardWrapper">
                {founders.map((expert, index) => {
                    return (
                        <div className="hostChefCardContainer cuiratoChefCardContainer" key={index}>
                            <div className="cuiratorChefCardImageWrapper">
                                <img className="hostChefCardImage" src={expert?.image} alt="img" />
                                <div className="curatorChefNameWrapper">
                                    <div className="hostChefNameWrapper">
                                        <div className="cuiratorChefName Satoshi">{expert.name}</div>
                                        <VerifiedIconSvg size={13.34} />
                                    </div>
                                    <div className="hostChefTimeWrapper" style={{ columnGap: 4 }} >
                                        <LocationGreySvg />
                                        <div className="hostChefTimeLabel Satoshi">{expert?.location}</div>
                                    </div>
                                </div>
                            </div>


                            <div className="curatorLabelContentWrapper">
                                <div className="curatorLabelContentLabel Satoshi">{expert?.bio}</div>
                                {/* <div className="curatorLabelContentDesc Satoshi">Star on Star!</div> */}
                            </div>

                            <div className="curatorCusineWrapper">
                                <div className="curatorCusineLabel Satoshi">Cuisines: </div>
                                <div className="curatorCusineDesc Satoshi"> {expert?.cuisines?.join(", ")} </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    )
}

export default FoundersCuratedComponent